var map = {
	"./back.svg": 1734,
	"./check.svg": 4397,
	"./chevron-left.svg": 1282,
	"./chevron-right.svg": 6985,
	"./close.svg": 5225,
	"./completedCircle.svg": 2382,
	"./delete.svg": 8414,
	"./download.svg": 8411,
	"./flip.svg": 7482,
	"./menu.svg": 8798,
	"./minus.svg": 3845,
	"./plus.svg": 3447,
	"./refresh.svg": 2748,
	"./sparkles.svg": 8662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3905;